export const clickoutTypes = {
  LEGACY: 'LEGACY_CLICKOUT_SERVICE',
  NEW: 'OFFERS_CLICKOUT_SERVICE'
};

const getClickoutType = (data, variantType) => {
  if (['vcId', 'offerIds'].includes(variantType)) {
    return clickoutTypes.LEGACY;
  }
  if (data && 'clickoutService' in data) {
    return data.clickoutService ? clickoutTypes.NEW : clickoutTypes.LEGACY;
  }

  return clickoutTypes.LEGACY;
};

const createDehydratedState = (data, variant, ids) => {
  const { apiKey, bookmakersFromOffers, offers } = data;

  const offersWithLogos = offers.map(offer => {
    const bookmaker = bookmakersFromOffers?.find(
      bookmaker => bookmaker?.id === offer?.bookmakerId
    );

    return {
      ...offer,
      bookmaker
    };
  });

  const variantType = data.variantType === 'slot' ? 'vcId' : data.variantType;

  return {
    mutations: [],
    queries: [
      {
        queryHash: `["${variant}","${apiKey}","${variantType}","${ids}"]`,
        queryKey: [variant, apiKey, variantType, ids],
        state: {
          data: offersWithLogos,
          dataUpdateCount: 1,
          dataUpdatedAt: Date.now(),
          error: null,
          errorUpdateCount: 0,
          errorUpdatedAt: 0,
          fetchFailureCount: 0,
          fetchFailureReason: null,
          fetchMeta: null,
          fetchStatus: 'idle',
          isInvalidated: false,
          status: 'success'
        }
      }
    ]
  };
};
export const createCxProps = ({
  data,
  theme,
  variant,
  initialOffersToShow,
  placeholders,
  poweredBy = '',
  analytics: { disableAnalytics, dataLayer },
  i18n
}) => {
  const {
    inheritFontFamily = false,
    variantType,
    recommendedMarketId,
    hash: widgetSlot,
    campaignName
  } = data;
  const clickoutServiceUrl = import.meta.env.VITE_OFFERS_CLICKOUT_SERVICE_URL;
  const clickoutService = getClickoutType(data, variantType);

  const analyticsImpressionEventData = {
    ...(widgetSlot &&
      campaignName && {
        widgetSlot,
        campaignName
      }),
    ...(recommendedMarketId ? { recommendedMarketId } : {})
  };

  switch (variantType) {
    case 'slot': {
      const analyticsDataLayer = disableAnalytics ? null : dataLayer;
      return {
        analyticsImpressionEventData,
        analyticsDataLayer,
        apiKey: data.apiKey,
        dehydratedState: createDehydratedState(
          data,
          variant,
          data.idForCxCache
        ),
        vcId: data.idForCxCache,
        disableAnalytics,
        theme,
        inheritFontFamily,
        placeholders,
        initialOffersToShow,
        i18n,
        gtmId: data?.gtmId,
        clickoutService,
        clickoutServiceUrl,
        pageUrl: window.location.pathname,
        poweredBy,
        recommendedMarketId: data?.recommendedMarketId
      };
    }

    case 'vcId': {
      data.apiKey = 'NO_API_KEY_VCID';
      return {
        analyticsImpressionEventData,
        analyticsDataLayer: window.ocConnectWidgetTracker,
        apiKey: data.apiKey,
        dehydratedState: createDehydratedState(
          data,
          variant,
          data.idForCxCache
        ),
        disableAnalytics,
        theme,
        vcId: data.idForCxCache,
        inheritFontFamily,
        placeholders,
        poweredBy,
        initialOffersToShow,
        clickoutService
      };
    }

    case 'offerIds': {
      data.apiKey = 'NO_API_KEY_OFFERIDS';
      return {
        analyticsImpressionEventData,
        analyticsDataLayer: window.ocConnectWidgetTracker,
        apiKey: data.apiKey,
        dehydratedState: createDehydratedState(
          data,
          variant,
          data.idForCxCache
        ),
        disableAnalytics,
        offerIds: data.idForCxCache,
        theme,
        inheritFontFamily,
        placeholders,
        poweredBy,
        initialOffersToShow,
        clickoutService
      };
    }
  }
};
